import isNumber from 'lodash/isNumber';

export const getWidth = (width: number | string): {width: string} => {
  if (!width) {
    return {width: '100%'};
  }
  return width && isNumber(width) ? {width: `${width}px`} : {width: `${width}`};
};
